
    import Vue from 'vue';
    export default {
      scrollToTop: true,
      head() {
        return {
          title: this.title ,
          meta: [{
              hid: 'og:title',
              property: 'og:title',
              content: this.title
            },
            {
              hid: 'twitter:title',
              property: 'twitter:title',
              content: this.title
            },
            {
            hid: 'description',
            name: 'description',
            content: 'Explore the full lyrics of Stotra "Ase Paatakee Deen" in both Marathi and English, with an option to switch between the two languages.'
          },
          {
            hid: 'og:description',
            property: 'og:description',
            content: 'Explore the full lyrics of Stotra "Ase Paatakee Deen" in both Marathi and English, with an option to switch between the two languages.'
          },
          {
            hid: 'twitter:description',
            property: 'twitter:description',
            content:'Swami Samarth, swami ashtak, स्वामी समर्थ अष्टक, Ase Paatakee Deen, shri swami samarth ashtak, swami samarth ashtak stotra, swami ashtak lyrics, ase patki swami samarth, स्वामी अष्टक, swami samarth ashtak lyrics, swami samarth, samarth ashtak lyrics marathi, samarth ashtak lyrics english, swami samarth ashtak lyrics'
          },
          {
            hid: 'keywords',
            name: 'keywords',
            content:'Ase Paatakee Deen, Swami Samarth, स्वामी समर्थ अष्टक, अक्कलकोट स्वामी स्तोत्र, shri swami samarth ashtak, swami samarth ashtak stotra, swami ashtak lyrics, ase patki swami samarth, स्वामी अष्टक, swami samarth ashtak, swami samarth ashtak lyrics, swami samarth ashtak lyrics english, swami samarth ashtak lyrics marathi, श्री स्वामी समर्थाष्टक, Ase Pataki Din Mi (Ashtak), swami ashtak, swami samarth ashtak lyrics' 
          },
          {
            hid: 'image',
            property: 'image',
            content: this.$config.siteUrl + '/img/stotra/swami-ashtak.webp'
          },
          {
            hid: 'og:image',
            property: 'og:image',
            content: this.$config.siteUrl + '/img/stotra/swami-ashtak.webp'
          },
          ],
        }
      },
    
      components: {
      },
      data() {
        return {
          title: 'Ase Paatakee Deen | Swami Samarth Ashtak - असें पातकी दीन(स्वामी समर्थ अष्टक)',
          langauageMarathi: true
        }
      },
      layout: 'detailsPage-withoutFooter',
      
      jsonld() {
    return {
      '@context': 'https://schema.org',
      "@graph": [{
        "@type": "Article",
        "mainEntityOfPage": {
          "@type": "WebPage",
          "@id": "https://goa.app/stotra/swami-ashtak"
        },
        "headline": "Ase Paatakee Deen - असें पातकी दीन(स्वामी समर्थ अष्टक)",
        "name" : "Ase Paatakee Deen - Swami Samarth Ashtak",
        "description": "Explore the full lyrics of stotra 'Ase Paatakee Deen' in both Marathi and English, with an option to switch between the two languages.",
        "image": this.$config.siteUrl + '/img/stotra/swami-ashtak.webp',  
        "author": {
          "@type": "Organization",
          "name": "Goa App",
          "url": "https://goa.app"
        },  
        "publisher": {
          "@type": "Organization",
          "name": "Goa App",
          "logo": {
            "@type": "ImageObject",
            "url": "https://goa.app/android-chrome-384x384.png"
          }
        },
        "datePublished": "2024-10-10T08:00:00+08:00",
        "dateModified": "2024-10-10T09:20:00+08:00"
      },]}
    },
  
  
      computed: {
  
      },
      methods:{
        changeLanguage:function () {
          this.langauageMarathi = !this.langauageMarathi
        }
      }
  
    }
  